import callApi from './partials/api';

export default {
    // 課程分類
    queryMetaInfo(typeId, cb) {
        callApi('get', `type-def/meta-info/`+ typeId, cb);
    },
};
